<template>
  <v-flex>
    <v-btn
      v-if="featureType === 'button'"
      featureBtnDisabled
      :color="featureBtnColor"
      @click="openDialog"
    >
      <span>{{ featureBtnText }}</span>
    </v-btn>

    <a v-if="featureType === 'link'" color="grey" @click="openDialog">
      {{ featureBtnText }}
    </a>

    <v-btn
      v-if="featureType === 'locationButton'"
      class="Btn"
      @click="openDialog"
    >
      <v-icon left>{{ locationBtnIcon }}</v-icon>
      <span>{{ locationBtnText }}</span>
    </v-btn>

    <div @click="openDialog" v-if="featureType == 'flag'">
      <v-btn icon dark>
        <gb-flag :code="featureFlag" :size="featureFlagSize" />
      </v-btn>
    </div>

    <v-text-field
      v-if="featureType === 'text'"
      :label="feature"
      class="text-capitalize"
      filled="true"
      @click="openDialog"
    >
    </v-text-field>

    <v-card
      v-if="featureType === 'card'"
      light
      color="#E0E0E0"
      @click="openDialog"
      class="Card"
    >
      <v-card-title class="text-capitalize">
        {{ feature }}
      </v-card-title>
      <v-card-text class="ImageInput__label">
        {{ $t('upcomingFeature.add') }} {{ feature }}
      </v-card-text>
    </v-card>

    <div v-if="featureType == 'image'">
      <p v-if="featureType == 'image'" class="ImageInput__label">
        {{ feature }}
      </p>
      <div
        v-if="featureType == 'image'"
        class="ImageInput__emptyField mt-2"
        @click="openDialog"
      >
        <div>
          <span>+</span>
        </div>
      </div>
    </div>

    <div @click="openDialog">
      <v-icon
        v-if="featureType == 'icon'"
        style="margin-top: 8px"
        :large="featureIconSizeL"
        :medium="featureIconSizeMedium"
        :color="featureIconColor"
        @click="openDialog"
      >
        {{ featureIcon }}
      </v-icon>
      <!--span
            v-if="featureIconText"
            >
            {{ featureIconText }}
            </span>
            <gif
            v-if="gifType"
            :gifType="gifType">
            </gif-->
    </div>

    <v-dialog v-model="isDialogOpen" light max-width="500">
      <v-card class="mx-auto" outlined primary>
        <v-card-title class="headline">
          {{ $t('upcomingFeature.title') }}
        </v-card-title>
        <v-card-text>
          {{ $tc('upcomingFeature.message', feature, { feature }) }}
        </v-card-text>
        <div v-if="isTracked">
          <v-card-text v-if="voteValue || !alreadyVotedUser">
            {{ $t('upcomingFeature.usefullFeature') }}
          </v-card-text>
          <v-layout v-if="voteValue || !alreadyVotedUser">
            <v-btn
              outline
              :disabled="voteValue == 'clickDown'"
              v-bind:color="voteValue === 'clickUp' ? 'green' : 'grey'"
              @click="submitOpinion('clickUp')"
            >
              <v-icon> mdi-thumb-up </v-icon>
            </v-btn>
            <v-btn
              outline
              :disabled="voteValue == 'clickUp'"
              v-bind:color="voteValue === 'clickDown' ? 'red' : 'grey'"
              @click="submitOpinion('clickDown')"
            >
              <v-icon> mdi-thumb-down </v-icon>
            </v-btn>
            <v-card-text v-if="voteValue">
              {{ $t('upcomingFeature.thanks') }}
            </v-card-text>
          </v-layout>
          <v-card-text v-if="alreadyVotedUser && !voteValue">
            {{ $t('upcomingFeature.alreadyVoted') }}
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
export default {
  name: 'UpcomingFeature',
  data() {
    return {
      isDialogOpen: false,
      locationBtnText: this.$t('pathForm.chooseLocation'),
      locationBtnIcon: 'mdi-map-marker',
      locationBtnClass: '',
      voteValue: '',
    };
  },
  props: {
    feature: {
      default: null,
    },
    featureType: {
      default: null,
    },
    featureIcon: {
      default: null,
    },
    featureIconSizeL: {
      type: Boolean,
      default: false,
    },
    featureIconSizeMedium: {
      type: Boolean,
      default: false,
    },
    featureIconColor: {
      default: null,
    },
    featureIconText: {
      default: null,
    },
    featureBtnText: {
      default: null,
    },
    featureBtnDisabled: {
      default: null,
    },
    featureBtnColor: {
      default: null,
    },
    featureFlag: {
      default: null,
    },
    featureFlagSize: {
      default: null,
    },
    gifType: {
      default: null,
    },
    isTracked: {
      default: null,
    },
  },
  methods: {
    async submitOpinion(value) {
      this.voteValue = value;
      try {
        if (!this.statsFeature) {
          await this.$store.dispatch('stats/CREATE_FEATURE', {
            newFeaturePayload: {
              name: this.isTracked,
              nbClicks: { clickUp: 0, clickDown: 0 },
              usersIds: [],
            },
            kuzzle: this.$kuzzle,
          });
        }
        let statsFeature = this.statsFeature;

        if (!statsFeature.usersIds.includes(this.userIndex)) {
          this.$store.commit('app/SET_LOADING');
          let newNbClicks = JSON.parse(JSON.stringify(statsFeature.nbClicks));
          newNbClicks[value] += 1;
          let newUserIds = [...statsFeature.usersIds, this.userIndex];

          await this.$store.dispatch('stats/UPDATE_VOTE_STATS_FEATURES', {
            featureId: this.statsFeatureId,
            featurePayload: { nbClicks: newNbClicks, usersIds: newUserIds },
            kuzzle: this.$kuzzle,
          });
        }
      } catch (error) {
        console.error(error.message);
      }
      await this.$store.commit('app/UNSET_LOADING');
    },
    openDialog() {
      this.isDialogOpen = true;
    },
  },
  computed: {
    publicMissions() {
      const { missions } = this.$store.state.missions;
      return Object.keys(missions)
        .map((key) => ({
          key,
          ...missions[key],
        }))
        .filter((mission) => mission._index === 'public');
    },
    userIndex() {
      return this.$store.getters['auth/currentUserIndex'];
    },
    statsFeatureId() {
      return this.$store.getters['stats/getStatsFeatureIdByName'](
        this.isTracked
      );
    },
    statsFeature() {
      return this.$store.getters['stats/getFeaturebyId'](this.statsFeatureId);
    },
    alreadyVotedUser() {
      if (
        this.statsFeature &&
        this.statsFeature.usersIds.includes(this.userIndex)
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped lang="sass">
a
  color:#ffffff !important
  text-decoration: underline;

.ImageInput__emptyField
  width: 125px
  height: 125px
  background: #e6e6e6
  cursor: pointer
  display: flex
  align-items: center
  justify-content: center
  border-radius: 4px

  div
    width: 100px
    height: 100px
    border: 4px dashed #c1c1c1
    border-radius: 4px
    display: flex
    justify-content: center
    align-items: center

    span
      color: #c1c1c1

.ImageInput__label
  color: #aaa !important

.Card
    width: 600px
    top: 20px

.Btn
    bottom: 10px
    left: 10px

.btn-flag
    margin-left: 3px;
    margin-right: 3px;
    width: 30px;
    height: 30px;

.selectedFlag
    border: 4px solid #009999 !important
    height: 32px
    width: 32px

a[data-v-850e218c]
    color: #9e9e9e !important;
    text-decoration: underline;
</style>
